import { useEffect, useRef } from 'react';
export function replaceExternalLocation(href: string) {
    window.location.replace(href);
}
export function ExternalGameRedirect({ href, replace = replaceExternalLocation }: {
    href: string;
    replace?: (href: string) => void;
}) {
    const lastDestination = useRef<string | null>(null);
    useEffect(() => {
        if (lastDestination.current === href) return;
        lastDestination.current = href;
        replace(href);
    }, [href, replace]);
    return <main className="route-loading"><p>Jargon 已迁至独立网站。<a href={href}>点击前往 Jargon ↗</a></p></main>;
}
